import React, { useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  Container,
  TitleWrapper,
  DialogButtonsWrapper,
} from "../adminGenerateCheck/AdminGeneratePageStyles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  TextField,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import { TextBox } from "../../atoms/Text Box/TextBox";
import {
  BigRedButton,
  ButtonVersion,
} from "../../atoms/BigRedButton/BigRedButtonAtom";
import useApiService from "../../utilities/useApiService";
import { useParams } from "react-router-dom";
import { IReport } from "../../network/models/Interfaces";

export interface EditReportDialogProps {
  open: boolean;
  onClose: () => void;
  report: IReport;
}

interface EditReportForm {
  description: string;
}

const EditReportDialog: React.FC<EditReportDialogProps> = ({
  open,
  onClose,
  report,
}) => {
  const { patchMethod } = useApiService();
  const queryClient = useQueryClient();
  const params: any = useParams();
  const { pharmacyId, requestId } = params;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<EditReportForm>();

  useEffect(() => {
    if (report) {
      reset({
        description: report.description,
      });
    }
  }, [report, reset]);

  const updateReportApi = async (data: EditReportForm) => {
    const response = await patchMethod(
      `/admin/pharmacies/${pharmacyId}/returnrequests/${requestId}/reports/${report.id}`,
      null,
      {
        params: {
          description: data.description,
        },
      },
    );

    return response.data;
  };

  const { mutate: updateReport, isLoading } = useMutation(updateReportApi, {
    onSuccess: () => {
      queryClient.invalidateQueries("reports");
      onClose();
    },
  });

  const onSubmit = (data: EditReportForm) => {
    updateReport(data);
  };

  return (
    <Container>
      <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TitleWrapper>
            <TextBox
              bodyFontSize={18}
              headerFontSize={24}
              image=""
              paragraphs={[""]}
              title={"Edit Report Description"}
              titleColor={"#A61C14"}
            />
          </TitleWrapper>

          <DialogContent>
            <TextField
              fullWidth
              label="Description"
              margin="normal"
              {...register("description", {
                required: "Description is required",
              })}
              error={!!errors.description}
              helperText={errors.description?.message}
            />
          </DialogContent>

          <DialogActions>
            <DialogButtonsWrapper>
              <BigRedButton
                text="CANCEL"
                version={ButtonVersion.SMALL}
                onClick={onClose}
              />

              <Button
                className="approveButton"
                type="submit"
                disabled={isLoading}
              >
                Save
              </Button>
            </DialogButtonsWrapper>
          </DialogActions>
        </form>
        
      </Dialog>
    </Container>
  );
};

export default EditReportDialog;
